/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnbanInputs */

const th_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกการระงับ`)
};

const en_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unban`)
};

const ja_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止を解除`)
};

const zh_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除封禁`)
};

const es_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear`)
};

const pt_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear`)
};

const id_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka blokir`)
};

const fr_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquer`)
};

const tl_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alisin sa ban`)
};

const vi_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ cấm`)
};

const ko_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차단 해제`)
};

const de_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entsperren`)
};

const ru_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать`)
};

const tr_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engeli kaldır`)
};

const it_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca`)
};

const pl_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odblokuj`)
};

const uk_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розблокувати`)
};

const hi_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबंध हटाएँ`)
};

const ar_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع الحظر`)
};

const ms_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka sekatan`)
};

const bn_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিষেধাজ্ঞা তুলুন`)
};

const zh_tw2_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除停權`)
};

const zh_hk2_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除停權`)
};

const ur_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پابندی ہٹائیں`)
};

const fa_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع مسدودی`)
};

const sw_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa zuio`)
};

const nl_unban = /** @type {(inputs: UnbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblokkeren`)
};

/**
* | output |
* | --- |
* | "Unban" |
*
* @param {UnbanInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const unban = /** @type {((inputs?: UnbanInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnbanInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_unban(inputs)
	if (locale === "ja") return ja_unban(inputs)
	if (locale === "zh") return zh_unban(inputs)
	if (locale === "es") return es_unban(inputs)
	if (locale === "pt") return pt_unban(inputs)
	if (locale === "id") return id_unban(inputs)
	if (locale === "fr") return fr_unban(inputs)
	if (locale === "tl") return tl_unban(inputs)
	if (locale === "vi") return vi_unban(inputs)
	if (locale === "ko") return ko_unban(inputs)
	if (locale === "de") return de_unban(inputs)
	if (locale === "ru") return ru_unban(inputs)
	if (locale === "tr") return tr_unban(inputs)
	if (locale === "it") return it_unban(inputs)
	if (locale === "pl") return pl_unban(inputs)
	if (locale === "uk") return uk_unban(inputs)
	if (locale === "hi") return hi_unban(inputs)
	if (locale === "ar") return ar_unban(inputs)
	if (locale === "ms") return ms_unban(inputs)
	if (locale === "bn") return bn_unban(inputs)
	if (locale === "zh-TW") return zh_tw2_unban(inputs)
	if (locale === "zh-HK") return zh_hk2_unban(inputs)
	if (locale === "ur") return ur_unban(inputs)
	if (locale === "fa") return fa_unban(inputs)
	if (locale === "sw") return sw_unban(inputs)
	if (locale === "nl") return nl_unban(inputs)
	return en_unban(inputs)
});